import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceHeader"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/ServiceHeader/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceLayout"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/ServiceLayout/index.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Alert/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Box/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Faq/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/IconButton/index.jsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/Services/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/icons/audit.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/icons/bookkeeping.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/icons/filing.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/icons/vat.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/accounting-mobile.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/images/accounting.jpg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/services/accounting/index.module.scss");
